<template>
    <label>{{ $e('Choose membership') }}</label>
    <RichSelect
        v-if="trigger.settings"
        v-model="trigger.settings.membership_id"
        modelValue="trigger.settings.membership_id"
        :settings="{ ajax: { url: this.restUrl('flow/memberships?vendor=rua'), dataType: 'json' } }"
        :ajaxUrl="restUrl('flow/memberships?vendor=rua')"
        :placeholder="'Select membership'"
        @select="membershipSelected"
    >
        <option :value="trigger.settings.membership_id" selected :key="trigger.settings.membership_id" v-if="trigger.settings && trigger.settings.membership_id">
            {{ trigger.settings.membership_title ? trigger.settings.membership_title : trigger.settings.membership_id }}
        </option>
    </RichSelect>
</template>

<script>
import RichSelect from "../../Global/RichSelect.vue"

export default {
    components: { RichSelect },
    props: {
        trigger:  { type: Object, required: true }
    },
    methods: {
        /**
         * Update the selected text
         */
        membershipSelected(selected) {
            this.trigger.settings.membership_title = selected.text
        },
    }
}
</script>
